import {useEffect, useState} from "react";

const LogoutCallback = () => {

    useEffect(() => {
        setTimeout(() => {
            window.close(); // 탭 닫기 시도
            window.location.href = "https://aimath.i-scream.co.kr"; // 닫히지 않으면 공홈 페이지로 리디렉션
        }, 500); // 0.5초 후 실행
    }, []); // 빈 배열을 사용해 한 번만 실행되도록 설정


    return (
        <div>
            <h2>로그아웃 중 입니다...</h2>
        </div>
    );
}

export default LogoutCallback;